import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  Button,
  Badge,
  Form,
  Modal,
} from "@themesberg/react-bootstrap";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { useParams } from "react-router-dom";
import { getAsset, createAssetAssign, getVendorList } from "../../app/api";
import axios from "axios";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import moment from "moment";
import swal from "sweetalert";
import Select from "react-select";
export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [vendorId, setVendorID] = useState("");
  const [assetId, setAssetID] = useState([]);
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [serial, setSerial] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [vin, setVin] = useState("");
  const [vendor2, setVendor2] = useState([]);
  const [vendor, setVendor] = useState("");
  const [model, setModel] = useState("");
  const [description, setDescritpion] = useState("");
  const [date, setDate] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);
  const fetchSingleAssets = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getAsset(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setAssetID(response.data?.data?.id);
      setTitle(response.data?.data?.title);
      setStatus(response.data?.data?.status);
      setSerial(response.data?.data?.serial_no);
      setMacAddress(response.data?.data?.mac_address);
      setVin(response.data?.data?.vin);
      setModel(response.data?.data?.model);
      setDescritpion(response.data?.data?.description);
      setType(response.data?.data?.type);
      setDate(response.data?.data?.created_at);
      setVendor(response.data?.data?.vendor_name);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleAssets();
  }, [id]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  useEffect(() => {
    const fetchvendorsList = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(getVendorList(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        // console.log("vendor dropdown", response.data?.data);
        setVendor2(response.data?.data);
      } catch (error) {
        // console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchvendorsList();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);

    try {
      const token = localStorage.getItem("token");
      const assetIdsArray = Array.isArray(assetId) ? assetId : [assetId];
      const AssestsData = {
        vendor_id: vendorId,
        asset_ids: assetIdsArray,
      };
      let response;

      response = await axios.post(createAssetAssign(), AssestsData, {
        headers: {
          "Content-Type": "application/json", // Set Content-Type to application/json
          "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
          "auth-token": `Bearer ${token}`,
        },
      });
      swal({
        text: "Asset Assigned Successfully",
        icon: "success",
      }).then(() => {
        fetchSingleAssets(id); // Re-fetch vendors instead of reloading the page
      });

      console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.message,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      setShow(false);
    }
  };
  const handleBackClick = () => {
    history.push(Routes.Assets.path);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block mb-md-0">
              <h4 className="mb-0">Asset Details</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Title:</p>
                        <p className="vendor-detail">{title}</p>{" "}
                      </Col>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Type:</p>
                        <p className="vendor-detail">{type}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Serial #</p>
                        <p className="vendor-detail">{serial}</p>{" "}
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Status:</p>
                        <p className="vendor-detail">
                          <Badge
                            pill
                            bg={
                              status === "exposed" || status === "sold"
                                ? "light"
                                : status === "assigned"
                                ? "danger"
                                : "primary"
                            }
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.85rem",
                              border: "1px solid #ddd",
                            }}
                          >
                            {status === "assigned"
                              ? !vendor
                                ? `${status} to no vendor`
                                : `${status} to ${vendor}`
                              : status}
                          </Badge>
                        </p>{" "}
                      </Col>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Type:</p>
                        <p className="vendor-detail">{type}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Serial #</p>
                        <p className="vendor-detail">{serial}</p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">MAC Address:</p>
                        <p className="vendor-detail">{macAddress}</p>{" "}
                      </Col>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">VIN #</p>
                        <p className="vendor-detail">{vin}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Model:</p>
                        <p className="vendor-detail">{model}</p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Assigned Vendor:</p>

                        <p className="vendor-detail">
                          {" "}
                          {status === "assigned" && vendor ? (
                            <>{vendor}</>
                          ) : (
                            <span className="fw-normal">
                              {" "}
                              <Badge
                                pill
                                bg="primary"
                                style={{
                                  padding: "0.4rem 1rem",
                                  fontSize: "0.85rem",
                                  border: "1px solid #ddd",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleShow()}
                              >
                                Assign to vendor
                              </Badge>
                            </span>
                          )}
                        </p>
                      </Col>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Created Date:</p>
                        <p className="vendor-detail">
                          {moment(date).format("MM/DD/YYYY HH:mm")}
                        </p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Description:</p>
                        <p className="vendor-detail">{description}</p>{" "}
                      </Col>
                    </Row>
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Modal className="p-3 modal-cont" show={show} onHide={handleClose}>
            <Modal.Header className="p-3 contact_header">
              <Modal.Title className="contact_header_title">
                Assign Assets
              </Modal.Title>
              <Button
                variant="danger"
                onClick={handleClose}
                className="contact_header_Btn"
              >
                &times;
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex align-items-center mb-2">
                <p className="pt-2 pb-2 mb-0">
                  Select the Vendor to Assign the Assest
                </p>
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group id="Vendor Name">
                  <Form.Label>Vendor Name</Form.Label>
                  <Select
                    options={vendor2.map((v) => ({
                      value: v.id, // Value to be stored
                      label: v.company_name, // Display text
                    }))}
                    value={
                      vendorId
                        ? {
                            value: vendorId,
                            label: vendor2.find((v) => v.id === vendorId)
                              ?.company_name,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      setVendorID(selectedOption ? selectedOption.value : "")
                    }
                    placeholder="Select Vendor"
                    isClearable // Allow clearing the selection
                    isSearchable // Allow typing to filter options
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "5px",
                        width: "100%",
                      }),
                    }}
                  />
                </Form.Group>

                <div className="pt-3">
                  <Button variant="primary" type="submit">
                    Assign Assests
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
};
